module.exports = "<div></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/empty-home/empty-home.component.html
// module id = ./src/app/home/empty-home/empty-home.component.html
// module chunks = main